import React from 'react';
import { Slider, Box } from '@mui/material';

const BrightnessSlider = ({ value, onChange }) => {
  return (
    <Box
      sx={{
        height: '200px', // Adjust the height as needed
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '20px auto',
      }}
    >
      <Slider
        orientation="vertical"
        value={value}
        onChange={(e, newValue) => onChange(newValue)}
        min={0}
        max={100}
        step={1}
        aria-label="Brightness"
        sx={{
          height: '100%',
          '& .MuiSlider-thumb': {
            width: '20px',
            height: '20px',
          },
          '& .MuiSlider-track': {
            width: '4px',
          },
          '& .MuiSlider-rail': {
            width: '4px',
          },
        }}
      />
    </Box>
  );
};

export default BrightnessSlider;
